export enum AutoCompleteTypeEnum {
  Countries,
}
